/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IBetWinData, IKarenData, IKarenGameData, IKarenInitData} from "./IKarenData";
import {IParsedStackedSymbolName, StackedSymbol} from "../../../core/reel/stackedsymbol/StackedSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {KarenGameConfig} from "../../KarenGameConfig";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {BetWinMode} from "../../../core/config/BetWinMode";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Karen} from "../../Karen";

export class KarenDataParser {

    constructor() {

    }

    public static parseXWPositions(rawData: IKarenData): number[] {
        const xWPos: number[] = [];
        for (let reelId: number = 0; reelId < 6; reelId++) {
            for (let row: number = 1; row <= rawData.evaluatedArea[reelId].length; row++) {
                if (rawData.reels[reelId][row] === "XW") {
                    xWPos[reelId] = row - 1;
                    break;
                } else {
                    xWPos[reelId] = -1;
                }
            }
        }
        return xWPos;
    }

    public static parseXWInfPositions(rawData: IKarenData): number[][] {
        const xWPos: number = rawData.reels[0].indexOf("XW2");
        const xWInfPos: number[][] = [];
        const mysterySymbol: string = rawData.evaluatedArea[0][xWPos - 1];
        for (let reelId: number = 0; reelId < 6; reelId++) {
            const infectedRow: number[] = [];
            for (let row: number = 0; row < rawData.evaluatedArea[reelId].length; row++) {
                if (rawData.evaluatedArea[reelId][row] === mysterySymbol) {
                    infectedRow.push(row);
                }
            }
            xWInfPos.push(infectedRow);
        }
        return xWInfPos;
    }

    public parseXWInfPositionsOnInit(rawData: IKarenData): number[][] {
        const xWPos: number = rawData.reels[0].indexOf("XW2");
        const xWInfPos: number[][] = [];
        const mysterySymbol: string = rawData.reelsEnteringFreespin[0][xWPos];
        for (let reelId: number = 0; reelId < 6; reelId++) {
            const infectedRow: number[] = [];
            for (let row: number = 0; row < rawData.reelsEnteringFreespin[reelId].length; row++) {
                if (rawData.reelsEnteringFreespin[reelId][row] === mysterySymbol && row > 0) {
                    infectedRow.push(row - 1);
                }
            }
            xWInfPos.push(infectedRow);
        }
        return xWInfPos;
    }

    public parseReels(rawData: IKarenData): string[][] {
        let reelSize: number[] = [2, 3, 4, 5, 6, 7];
        for (let reelId: number = 0; reelId < reelSize.length; reelId++) {
            for (let symId = 0; symId < reelSize[reelId] + 2; symId++) {
                if (rawData.reels[reelId][symId]) {
                } else {
                    rawData.reels[reelId][symId] = "L1";
                }
            }
        }
        return this.parseStackedSymbolsInReels(rawData.reels);
    }

    public parseInitReels(rawData: IKarenInitData): string[][] {
        let reels: string[][] = rawData.reels;
        if (rawData.mode == GameMode.NORMAL && rawData.nextMode === GameMode.FREESPIN) {
            if (rawData.isRestoreState) {
                reels = rawData.reelsEnteringFreespin;
            }
        }
        let reelSize: number[] = [2, 3, 4, 5, 6, 7];
        for (let reelId: number = 0; reelId < reelSize.length; reelId++) {
            for (let symId = 0; symId < reelSize[reelId] + 2; symId++) {
                if (reels[reelId][symId]) {
                } else {
                    reels[reelId][symId] = "L1";
                }
            }
        }
        return this.parseStackedSymbolsInReels(reels);
    }

    // Always start to parse the reel from the bottom because in all cases the bottom of the reel is already known.

    public parseEvaluatedArea(rawData: IKarenData): string[][] {
        return (rawData.evaluatedArea);
    }

    // Init Data

    public parseStackedSymbolsInReels(rawReels: string[][], parsedSymbolNamesUnder?: string[]): string[][] {
        let result: string[][] = [];

        rawReels.forEach((rawReel, reelId) => {
            result.push(this.parseStackedSymbolsInReel(rawReel, reelId, parsedSymbolNamesUnder == null ? undefined : parsedSymbolNamesUnder[reelId]));
        });

        return result;
    }

    // Game Data:

    // For special cases like the reel is up side down, please create your own parsing.
    public parseStackedSymbolsInReel(rawReel: string[], reelIndex: number, parsedSymbolNameUnder?: string): string[] {
        const input: string[] = rawReel.concat();
        const result: string[] = [];

        if (parsedSymbolNameUnder == null) {
            let bottomStackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1], reelIndex);
            // Find out if the reel has half stacked symbols in the bottom
            if (bottomStackedSymName.isStacked) {
                let i: number;
                for (i = 1; i < input.length; i++) {
                    const testStackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1 - i], reelIndex);
                    if (testStackedSymName.isStacked && testStackedSymName.symName === bottomStackedSymName.symName) {
                        bottomStackedSymName = testStackedSymName;
                    } else {
                        break;
                    }
                }
                // i is the first symbol that's not in the stack.
                i = i % bottomStackedSymName.totalNum; // If num of stacked symbols in the bottom is bigger than stacked.totalNum.
                parsedSymbolNameUnder = `${bottomStackedSymName.symName}*${i.toString()}`;
            } else {
                parsedSymbolNameUnder = "NonStackedDummySym";
            }
        }

        while (input.length > 0) {
            const stackedSymNameUnder: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(result.length > 0 ? result[0] : parsedSymbolNameUnder, reelIndex);
            const stackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input.pop()!, reelIndex);

            // For continue stacked symbol
            if (stackedSymNameUnder.isStacked && stackedSymNameUnder.index > 0) {
                if (!stackedSymName.isStacked || stackedSymName.symName !== stackedSymNameUnder.symName) {
                    debugger;
                    Logger.logDev("If you are using the outcome setter, this might be a case that the outcome made an illegal server data. Please take to the server dev to check if that worth a fix.");
                    throw new Error(`ServerDataParser.parseStackedSymbolsInReel():reelId = ${reelIndex}, reelData = ${rawReel.toString()}, symName = ${stackedSymName.symName}, the symbol should be ${stackedSymName.totalNum}-stacked!`);
                }
                result.unshift(`${stackedSymName.symName}*${(stackedSymNameUnder.index - 1).toString()}`);
                continue;
            }

            // For starting a new stacked symbol
            if (stackedSymName.isStacked) {
                result.unshift(`${stackedSymName.symName}*${(stackedSymName.totalNum - 1).toString()}`);
                continue;
            }

            // For non stacked symbol
            result.unshift(stackedSymName.symName);
        }

        return result;
    }

    public parseInitReelSet(rawData: IKarenInitData): string {
        if (rawData.initReelSet) {
            return rawData.initReelSet;
        }

        Logger.logDev("KarenDataParser.parseInitReelSet(): initReelSet is not provide, use nextReelSetName for init. This value is needed only if your game have full Stacked reel.");
        let reelSet: string = rawData.mode + "_REELSET";
        if (rawData.mode == GameMode.NORMAL) {
            reelSet = "BASE_REELSET";
        }
        return reelSet;
    }

    public parseBetWins(rawData: IKarenGameData): IBetWinData[] {
        switch (KarenGameConfig.BET_WIN_MODE) {
            case BetWinMode.BET_LINE:
                return rawData.betLineWins!;
            case BetWinMode.BET_WAY:
                return rawData.betWayWins!;
            default:
                debugger;
                throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
    }

    public parseWinRatio(winRatio: number): IWinRatioConfig | null {
        let ratioConfigs: IWinRatioConfig[] = KarenGameConfig.WIN_RATIOS;
        let winRatioIndex: number = 0;
        let ratioConfig;
        for (let i: number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if (winRatio >= config.ratio) {
                ratioConfig = config;
                winRatioIndex = i;
                break;
            }
        }

        if (ratioConfig) {
            return {
                ratio: winRatio,
                name: ratioConfig.name,
                duration: ratioConfig.duration,
                bigWinLevel: ratioConfig.bigWinLevel,
                winRatioIndex: winRatioIndex
            }
        }
        return null;
    }

    public parseScatterPositionsEnteringFS(rawData: IKarenData): number[] {
        let scatterPosition: number[] = [-1, -1, -1, -1, -1, -1];
        if (rawData.reels) {
            rawData.reels!.forEach((arr: string[], reel: number) => {
                let pos: number = arr.indexOf("S");
                if (pos > 0 && pos !== arr.length - 1) {
                    scatterPosition[reel] = pos - 1;
                }
            });
        }
        return scatterPosition;
    }

    public calculateReelNudge(rawData: IKarenData): boolean {
        const wildIndex: number = rawData.reels[5].indexOf("W", 1);
        return wildIndex > -1 && wildIndex < rawData.reels![5].length;
    }

    public parseStickyPositions(rawData: IKarenData): number[] {
        let stickyXWFSPostions: number[] = [-1, -1, -1, -1, -1];
        for (let reelIndx: number = 0; reelIndx < 6; reelIndx++) {
            stickyXWFSPostions[reelIndx] = rawData.stickyXWaysFSPositions![reelIndx] > -1 ? rawData.stickyXWaysFSPositions[reelIndx] : -1;
        }
        return stickyXWFSPostions
    }
}
